import Grid from '@mui/material/Grid';
import isGroupResponse from 'utils/typeGuards/isGroupResponse';
import GroupCard from 'components/GroupCard/GroupCard';
import OrganisationCard from 'components/OrganisationCard/OrganisationCard';
import { Group, GroupResponseV2, OrganisationResponse } from 'api/httpEntities';

type OrganisationOrGroupListProps = {
  organisationsOrGroups: (OrganisationResponse | GroupResponseV2)[];
  groupOrganisations?: Record<string, Group>;
  group?: Group;
};

const OrganisationOrGroupList = ({
  organisationsOrGroups,
  groupOrganisations,
  group,
}: OrganisationOrGroupListProps) => {
  return (
    <Grid
      container
      spacing={2}
      data-testid="organisation-list"
      sx={() => ({
        height: '100%',
        marginTop: '-8px',
      })}
    >
      {organisationsOrGroups.map((item) => {
        if (isGroupResponse(item)) {
          return <GroupCard key={item.id} group={item} />;
        }

        let parent: Group | undefined;
        const { id, name } = item;
        const organisationGroup =
          'organisationGroup' in item ? item.organisationGroup : undefined;

        if (groupOrganisations && groupOrganisations[id]) {
          parent = groupOrganisations[id];
        }

        if (group) {
          parent = group;
        }

        return (
          <OrganisationCard
            key={id}
            id={id}
            name={name}
            group={parent || organisationGroup}
          />
        );
      })}
    </Grid>
  );
};
export default OrganisationOrGroupList;
